export const SET_TABLE_OPTIONS = 'SET_TABLE_OPTIONS';
export const RESET_TABLE_OPTIONS = 'RESET_TABLE_OPTIONS';
export const RESET_TABLE_OPTIONS_BY_TYPE = 'RESET_TABLE_OPTIONS_BY_TYPE';
export const SANITIZE_TABLE_OPTIONS = 'SANITIZE_TABLE_OPTIONS';

export const SET_SELECTED = 'SET_SELECTED';
export const RESET_SELECTED = 'RESET_SELECTED';
export const RESET_SELECTED_BY_TYPE = 'RESET_SELECTED_BY_TYPE';
